import Register from '../utils/Register';

export default class BootstrapTooltips {

	constructor ($container) {
		document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
			const title = el.getAttribute('data-bs-title') ?? el.getAttribute('title');
			if (typeof title !== 'string' || title.trim() === '') {
				return;
			}
			new bootstrap.Tooltip(el);
		});
	}

	static init ($container) {
		new BootstrapTooltips($container);
	}
}

(new Register()).registerCallback(BootstrapTooltips.init, 'BootstrapTooltips.init');